/// <amd-module name="SuiteCommerce.GridOrder.Cell.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Cell.View", ["require", "exports", "underscore", "Backbone", "SuiteCommerce.GridOrder.Cell.Model", "SuiteCommerce.GridOrder.MatrixItemOption.Model", "SuiteCommerce.GridOrder.MatrixItemOption.View", "SuiteCommerce.GridOrder.MatrixChildItem.Model", "SuiteCommerce.GridOrder.MatrixChildItem.Prototype", "SuiteCommerce.GridOrder.PriceSchedule.Model", "SuiteCommerce.GridOrder.PriceSchedule.View"], function (require, exports, _, Backbone_1, GridOrder_Cell_Model_1, GridOrder_Cell_MatrixItemOption_Model_1, GridOrder_Cell_MatrixItemOption_ViewPrototype_1, GridOrder_Cell_MatrixChildItem_Model_1, GridOrder_Cell_MatrixChildItem_ViewPrototype_1, GridOrder_Cell_PriceSchedule_Model_1, GridOrder_Cell_PriceSchedule_ViewPrototype_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CellView = /** @class */ (function (_super) {
        __extends(CellView, _super);
        function CellView(options) {
            var _this = _super.call(this, options) || this;
            var viewPrototype = _this.getViewPrototypeForModel();
            _.extend(_this, viewPrototype.prototype);
            _this.container = options.container;
            return _this;
        }
        CellView.prototype.getViewPrototypeForModel = function () {
            if (GridOrder_Cell_Model_1.isInstanceOf(this.model, GridOrder_Cell_MatrixItemOption_Model_1.MatrixItemOptionModel)) {
                return GridOrder_Cell_MatrixItemOption_ViewPrototype_1.MatrixItemOptionViewPrototype;
            }
            if (GridOrder_Cell_Model_1.isInstanceOf(this.model, GridOrder_Cell_MatrixChildItem_Model_1.MatrixChildItemModel)) {
                return GridOrder_Cell_MatrixChildItem_ViewPrototype_1.MatrixChildItemViewPrototype;
            }
            if (GridOrder_Cell_Model_1.isInstanceOf(this.model, GridOrder_Cell_PriceSchedule_Model_1.PriceScheduleModel)) {
                return GridOrder_Cell_PriceSchedule_ViewPrototype_1.PriceScheduleViewPrototype;
            }
            return;
        };
        return CellView;
    }(Backbone_1.View));
    exports.CellView = CellView;
});
